<template>
  <section :class="{ 'section-builder-portable-text': true }">
    <GeneralTheme :theme="configuration">
      <PortableText
        v-if="sectionBuilderPortableText"
        :portable-data="sectionBuilderPortableText"
      />
    </GeneralTheme>
  </section>
</template>
<script setup lang="ts">
import GeneralTheme from '~/components/Molecules/Themes/GeneralTheme.vue';
import PortableText from '~/components/Atmos/PortableText/PortableText.vue';
import type { SectionBuilderPortableText } from '~/sanity/types';

defineProps<SectionBuilderPortableText>();
</script>

<style lang="scss" scoped></style>
